import { CircularProgress, Grid } from "@material-ui/core";
import React from "react";
import { MainView } from "../../modules/mainview";
import classes from "./index.module.scss";
import { LeftContentInvoicesList } from "./left-content";
import { RouteComponentProps } from "react-router-dom";
import { RigthContentInvoicesList } from "./rigth-content";
import { XUANAPI } from "modules/uri";
import Modal from "../../modules/UserModal";
import { commonErrorMessage } from "modules/constant";

export function EInvoicesListPage(props: RouteComponentProps) {
  const [loading, setLoading] = React.useState<boolean>(true);
  const [invoices, setInvoices] = React.useState<any[]>([]);
  const [errMessage, setErrMessage] = React.useState<string>("");

  const getInvoices = async (policyNum: string, token: string) => {
    try {
      const resp = await fetch(`${XUANAPI}/${policyNum}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const respData = await resp.json();
      return respData;
    } catch (err) {
      setErrMessage(commonErrorMessage);
      return [];
    }
  };

  const handleCloseModal = () => {
    setErrMessage("");
    props.history.goBack();
  };

  React.useEffect(() => {
    const init = async (policyNum: string, token: string | null) => {
      if (policyNum) {
        if (!token) {
          props.history.goBack();
          return;
        }
        const list = await getInvoices(policyNum, token);
        setInvoices(list);
      }
      setLoading(false);
    };

    const policyNumber = (props.match.params as any).policynumber || null;
    const token = localStorage.getItem("token") || null;

    init(policyNumber, token);

    // eslint-disable-next-line
  }, []);

  return (
    <MainView>
      <section className={classes.wrapper}>
        <div className={classes.bgGrey}></div>
        <div className={classes.blueBg}></div>
        <div className={classes.mainContent}>
          {loading ? (
            <div className={classes.initLoading}>
              <CircularProgress size={80} />
            </div>
          ) : invoices.length ? (
            <Grid container>
              <Grid item xs={12} md={5}>
                <LeftContentInvoicesList
                  policyNumber={invoices[0].polNum || ""}
                  customerName={invoices[0].clientFullName || ""}
                />
              </Grid>
              <Grid item xs={12} md={7}>
                <RigthContentInvoicesList invoices={invoices} />
              </Grid>
            </Grid>
          ) : (
            <div className={classes.noData}>Không có dữ liệu</div>
          )}
        </div>
      </section>
      <Modal
        title="Thông báo"
        content={errMessage}
        titleSubmit="Thoát"
        open={errMessage ? true : false}
        handleSubmit={handleCloseModal}
      />
    </MainView>
  );
}
